import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  content: string[];
  isOpen: boolean;
  onClick: () => void;
}
export function AccordionItem({
  title,
  content,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-white/20 rounded-lg mb-3 overflow-hidden bg-zinc-900/50" data-id="element-92">
      <button className="w-full px-4 md:px-5 py-3.5 md:py-4 flex justify-between items-center gap-3 text-left focus:outline-none hover:bg-zinc-800/50 transition-colors" onClick={onClick} data-id="element-93">
        <span className="font-bold text-sm md:text-lg text-white leading-snug" data-id="element-94">
          {title}
        </span>
        {isOpen ? <ChevronUp className="text-[var(--pd-green)] w-5 h-5 md:w-6 md:h-6 flex-shrink-0" data-id="element-95" /> : <ChevronDown className="text-[var(--pd-green)] w-5 h-5 md:w-6 md:h-6 flex-shrink-0" data-id="element-96" />}
      </button>
      <AnimatePresence data-id="element-97">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-98">
            <div className="px-5 pb-4 pt-1" data-id="element-99">
              <ul className="space-y-2" data-id="element-100">
                {content.map((item, index) => <li key={index} className="flex items-start text-zinc-300" data-id="element-101">
                    <span className="text-[var(--pd-green)] mr-2 mt-1 text-sm" data-id="element-102">
                      ►
                    </span>
                    <span data-id="element-103">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}